import { css } from '@/styled-system/css';

export const layoutContentStyles = css.raw({
  display: 'grid',
  padding: 'Layout.Content.padding',
  borderRadius: 'Layout.Content',
  backgroundColor: 'Layout.Content.bg',
});
